/**
 * Parameter encoding for the generated API clients.
 *
 * The generator's own encoder only knows `date-time`: it calls `toISOString()` for that and
 * `String(value)` for everything else. A `format: date` parameter is typed as `Date` but
 * falls into the `String(value)` branch, so a real `Date` reaches the server as
 * `Mon Jan 13 2026 00:00:00 GMT+0100 (CET)` and the request fails with a 400.
 *
 * This encoder handles `date` as the calendar day it is, taken in the local zone so a day
 * picked on screen is the day that is sent — `toISOString()` would shift it to the previous
 * day for any clock east of UTC, which is every clock we run in.
 *
 * Install it on a client's `Configuration` as `encodeParam`.
 */
export function encodeApiParam(param: {
  name: string;
  value: unknown;
  in: string;
  style: string;
  explode: boolean;
  dataType: string;
  dataFormat: string | undefined;
}): string {
  const { value, dataFormat } = param;

  if (value instanceof Date) {
    return encodeURIComponent(dataFormat === 'date' ? toLocalIsoDay(value) : value.toISOString());
  }

  return encodeURIComponent(String(value));
}

function toLocalIsoDay(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
